import { useEffect, useState } from "react";
import GenericGrid from "../../common/GenericGrid";
import { Column } from "primereact/column";
import CmsService from "../../../service/CmsService";
import { CrtItemForm } from "./CrtItemForm";
import { useParams } from "react-router-dom";
import CrtPanel from "./CrtPanel";
import { useTranslation } from "react-i18next";

export function CrtPage()
{
    const {t}=useTranslation();
    let {id} = useParams();
    
    const [crt,setCrt]=useState({});
    const [reload,setReload]=useState(false);
    const [items,setItems]=useState([]);

    const loadRecords=()=>{
        var ret = CmsService.getCrtItems(id);
        ret.then((recs)=>{
            setItems(recs);
            setReload(false);
        });
        return ret;
    }
    const commandAction=()=>{}
    const selectionChanged=()=>{}

    const insertItem=(parentId,rec,recType)=>{
        return CmsService.createCrtItem(id,rec);
    }
    const updateItem=(rec)=>{
        return CmsService.updateCrtItem(id,rec);
    }
    const deleteRecords=(ids)=>{
        return CmsService.deleteCrtItems(id,ids);
    }
    const conditionBody=(item)=>{
        if(!item.criteria)
            return '';
        var txt='';
        item.criteria.forEach(cond => {
            if(cond.field)
            {
                if(txt.length>0)
                    txt=txt+' '+t('AND')+' ';
                txt=txt+cond.field.name+' '+cond.operator+' '+cond.value+' ';
            }
        });
        return txt;
    }
	const initItem=()=>{
		return {catType:'TOPIC'};
	}    
    useEffect(()=>{
        CmsService.getCrt(id).then((rec)=>{
            setCrt(rec.crt);
            setItems(rec.items);
            setReload(false);
        });
    },[]);
    return(
        <>
        <div className="grid">
            <div className="col-12">
                <div className="card card-w-title shadow-1">
                    <CrtPanel crt={crt}/>
                    <GenericGrid dialogHeader={t("Criterion")} recType="CrtItem" loadRecords={loadRecords} reload={reload}
                            parentId={id} dataKey="id" form={CrtItemForm}
                            selectionChanged={selectionChanged} insertRecord={insertItem} 
                            updateRecord={updateItem} initRecord={initItem} deleteRecords={deleteRecords}
                            insertMenu deleteMenu editButton
                        > 
                        <Column header={t("Id")} field="id" style={{width:'5%'}} sortable></Column>
                        <Column header={t("Ord")} field="ord" style={{width:'5%'}} sortable></Column>
                        <Column header={t("Path")} field='path' style={{minWidth:'50px'}} sortable/>
                        <Column header={t("Course")} field='courseName' style={{minWidth:'150px'}} sortable/>
                        <Column header={t("Topic")} field='topicName' style={{minWidth:'150px'}} sortable/>
                        <Column header={t("Type")} field='itemType' sortable/>
                        <Column header={t("Conditions")} field='conditions' body={conditionBody} style={{width:'20%'}}/>
                        <Column header={t("Questions_Required")} field='questions'/>
                        <Column header={t("Section_No")} field='section'/>
                    </GenericGrid>
                </div>
            </div>
        </div>
        </>
    )
}